const DocIcon = () => {
    return (<svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" >
        <path d="M13 3L16 6L19 9M13 3L5 3L5 21L19 21L19 9M13 3L13 9L19 9" stroke="currentColor" strokeLinejoin="round" />
    </svg>)
}

export default DocIcon